import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { TypeAheadAvailableNodes } from '@atlaskit/editor-common/type-ahead';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { TypeAheadMenu as TypeAheadMenuModern } from './modern/TypeAheadMenu';
import { TypeAheadMenu } from './TypeAheadMenu';
export function ContentComponent(_ref) {
  var _typeAheadState$trigg;
  var api = _ref.api,
    editorView = _ref.editorView,
    popupMountRef = _ref.popupMountRef;
  var _useSharedPluginState = useSharedPluginState(api, ['typeAhead']),
    typeAheadState = _useSharedPluginState.typeAheadState;
  if (!typeAheadState) {
    return null;
  }
  if (
  // TODO: ED-26959 - Also requires a check for editor appearance (needs to be enabled for full-page/full-width editor only ?)
  !editorExperiment('platform_editor_insertion', 'control') && ((_typeAheadState$trigg = typeAheadState.triggerHandler) === null || _typeAheadState$trigg === void 0 ? void 0 : _typeAheadState$trigg.id) === TypeAheadAvailableNodes.QUICK_INSERT) {
    return /*#__PURE__*/React.createElement(TypeAheadMenuModern, {
      editorView: editorView,
      popupMountRef: popupMountRef,
      typeAheadState: typeAheadState,
      api: api
    });
  } else {
    return /*#__PURE__*/React.createElement(TypeAheadMenu, {
      editorView: editorView,
      popupMountRef: popupMountRef,
      typeAheadState: typeAheadState,
      api: api
    });
  }
}